import React from 'react';

type ScrollableListBoxProps = {
    height?: string;
    items: Record<string, any>[];
    listItemRenderer: (item: Record<string, any>, key: number) => JSX.Element;
};

const ScrollableListBox = ({ height, items, listItemRenderer }: ScrollableListBoxProps): JSX.Element => {
    return (
        <section
            className="component-scrollable-list-box"
            style={{ maxHeight: height ?? '220px' }}
        >
            {items.map((item, index) => listItemRenderer(item, index))}
        </section>
    );
};

export default ScrollableListBox;
